module.exports = {"attributes":{"width":"14","height":"13","viewBox":"0 0 14 13","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M2 11h11a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v10zm3.9-2.6A1 1 0 0 1 4 7.6l2-4a1 1 0 0 1 1.8 0L9 5.9l3-5.4a1 1 0 1 1 1.8 1l-4 7a1 1 0 0 1-1.8 0L7 6.1 5.9 8.4z\"/>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/chart.svg
// module id = 1384
// module chunks = 0